import { apiClient } from '../apiClient';

export const PATHS = {
  DISCLAIMERS: '/api/v1/state-compliance/disclaimer',
} as const;

// Field names mirror the API (camelized): the backend ships the *untranslated*
// copy as `untranslated_disclaimer_{title,description}` → humps →
// `untranslatedDisclaimer{Title,Description}`. Matches stylos's
// StateComplianceDisclaimerPage. The description is markdown.
export type StateComplianceDisclaimer = {
  uuid: string;
  state: string;
  untranslatedDisclaimerTitle: string;
  untranslatedDisclaimerDescription: string;
};

export async function fetchStateComplianceDisclaimers(
  signal?: AbortSignal
): Promise<StateComplianceDisclaimer[]> {
  const res = await apiClient.get<{ disclaimers?: StateComplianceDisclaimer[] }>(
    PATHS.DISCLAIMERS,
    {
      signal,
    }
  );
  return res.data?.disclaimers ?? [];
}
